export const FleetVendorsResource = {
  name: "Vendor",
  path: "/fleets/settings/vendors",
  access: ["read-fleetVendors"],
};
